/** Route params are strings; channel `_id` from API/Redux may differ by type. */
export const channelIdsEqual = (a, b) => a != null && b != null && String(a) === String(b);

export const firstVisibleChannelId = (visibleChannels = []) => {
  const channel = visibleChannels.find(c => !c.separator && c._id);
  return channel?._id || null;
};

/**
 * Where `/home/messages` should go once the member list has settled.
 * Returns a channel id to navigate to, or null to stay (empty pane).
 * Never returns '' — that produced `/home/messages/` and a blank chat.
 */
export default function resolveMessagesChannelRedirect({
  loading,
  channelId,
  firstId,
  channelInList,
} = {}) {
  if (loading) return null;
  if (!firstId) return null;
  const selectedId = channelId || null;
  if (!selectedId) return firstId;
  if (!channelInList) return firstId;
  return null;
}
